export default __webpack_public_path__ + "7e657f55c4629315cbe86a9ee672bcf5.png";